const initFilters = function () {
  const filterButtons = document.querySelectorAll("button.current-filter");
  filterButtons.forEach((b) => {
    b.addEventListener("click", () => {
      let f = b.getAttribute("data-field");
      let select = document.querySelector(`[data-sf-field-name=${f}] select`);
      let event = new Event("change", { bubbles: true });
      select.value = "";
      select.dispatchEvent(event);
    });
  });
};

export { initFilters };
